<div ng-controller="sieveDetailsController as ctrl">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>